<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-08-28 11:34:12
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-08-28 16:02:21
 * @FilePath: \合联\oms\src\view\commissionManagement\businessCommissionConfig\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/commissionManagement/businessCommissionConfig";
export default {
  name: "businessCommissionConfig",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 1000,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              sale_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              international_price: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              local_price: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              israel_price: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              bag_task: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              dbl_task: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              dbl_rate: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              start_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date",
                },
              ],
              end_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date",
                },
              ],
            },
          },
          grid: [
            { sale_id: 24 },
            { international_price: 12, local_price: 12 },
            { israel_price: 24 },
            { bag_task: 12, dbl_task: 12 },
            { dbl_rate: 24 },
            { start_time: 12, end_time: 12 },
            { bag_team_price: 12, dbl_team_rate: 12 },
          ],
          fields: [
            {
              name: this.$tz("销售名称"),
              key: "sale_id",
              placeholder() {
                return this.$tz("销售名称");
              },
              component: "Select",
              options: [],
              optionsFn: "salesman",
              optionsKey: "",
            },
            {
              name: this.$tz("国际,小包,价格"),
              key: "international_price",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("本地,小包,价格"),
              key: "local_price",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("中国到以色列,小包,价格"),
              key: "israel_price",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$tz("小包,任务"),
              key: "bag_task",
              component: "Input",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$tz("双清,任务"),
              key: "dbl_task",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("双清,利率"),
              key: "dbl_rate",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$tz("有效期,开始时间"),
              key: "start_time",
              placeholder: () => this.$tz("有效期,开始时间"),
              component: "DatePicker",
              format: "YYYY-MM-DD",
              disabledDate: true,

              bind: {
                type: "date",
              },
            },
            {
              name: () => this.$tz("有效期,结束时间"),
              key: "end_time",
              placeholder: () => this.$tz("有效期,结束时间"),
              component: "DatePicker",
              format: "YYYY-MM-DD",
              disabledDate: true,

              bind: {
                type: "date",
              },
            },
            {
              name: this.$tz("团队管理,小包,价格"),
              key: "bag_team_price",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("团队管理,双清,利率"),
              key: "dbl_team_rate",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "sale_id",
            placeholder() {
              return this.$tz("销售名称");
            },
            component: "Select",
            options: [],
            optionsFn: "salesman",
            optionsKey: "",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$tz("销售名称"),
          key: "sale_name",
          minWidth: 130,
        },
        {
          name: () => this.$tz("有效期,开始时间"),
          key: "start_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("有效期,结束时间"),
          key: "end_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("国际,小包,价格"),
          key: "international_price",
          minWidth: 130,
        },
        {
          name: () => this.$tz("本地,小包,价格"),
          key: "local_price",
          minWidth: 130,
        },
        {
          name: () => this.$tz("中国到以色列,小包,价格"),
          key: "israel_price",
          minWidth: 130,
        },
        {
          name: () => this.$tz("小包,任务"),
          key: "bag_task",
          minWidth: 130,
        },
        {
          name: () => this.$tz("双清,任务"),
          key: "dbl_task",
          minWidth: 130,
        },
        {
          name: () => this.$tz("双清,利润比例"),
          key: "dbl_rate",
          minWidth: 130,
        },
        {
          name: () => this.$tz("团队管理,小包,价格"),
          key: "bag_team_price",
          minWidth: 130,
        },
        {
          name: () => this.$tz("团队管理,双清,利润比例"),
          key: "dbl_team_rate",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("编辑"),
              type: "edit",
              fnName: "edit",
              bind: {
                type: "primary",
              },
              id: "",
            },
          ],
          methods: {
            edit({ row }) {
              this.getModal("add").open(row, function () {
                this.setTitle(this.$tz("编辑"));
              });
            },
            del() {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>